import { RequiresActivationConstraintWithLimitsFormValues } from '@occc/feat-constraints';
import { Operation } from '@occc-app/offerHelpers/types';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';

export const getRequiresActivationConstraintAndLimitsDeleteOperations = (
  activation: RequiresActivationConstraintWithLimitsFormValues,
): Operation[] => {
  const operations: Operation[] = [];
  const constraintId = activation.requiresActivation.id;
  const globalLimitId = activation.global.id;
  const membershipLimitId = activation.membership.id;

  if (constraintId) {
    operations.push(makeDeleteOperation('constraintDelete', constraintId));
  }

  if (globalLimitId) {
    operations.push(makeDeleteOperation('limitDelete', globalLimitId));
  }

  if (membershipLimitId) {
    operations.push(makeDeleteOperation('limitDelete', membershipLimitId));
  }

  return operations;
};
